import {
    Autocomplete,
    Button,
    Card,
    CardActions,
    CardContent,
    Grid,
    Table,
    TableContainer,
    TableHead,
    TableSortLabel,
    TextField,
    Typography
} from '@mui/material';
import { IconPencil } from '@tabler/icons';
import React from 'react';
import { gridSpacing } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import { useState } from 'react';
import { useEffect } from 'react';
import { useApi } from 'Service/axios';
import { Box, display } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { CircularProgress } from '@mui/material';
import ActionButtons from './components/ActionButtons';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import EventNoteIcon from '@mui/icons-material/EventNote';
import HoverSocialCard from './components/HoverCard';
import { toast } from 'react-toastify';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FirstModal from './components/FirstModal';
import SecondModal from './components/SecondModal';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';

const OrdemFP = () => {
    ////////////////////////////////////// INSTANCIAS /////////////////////////////////////////
    const columns = [
        { field: 'ord_in_codigo', headerName: 'Ordem', width: 80 },
        { field: 'ord_dt_confirmacao', headerName: 'Emissão', width: 100 },
        { field: 'pro_in_codigo', headerName: 'Código', width: 70 },
        { field: 'pro_st_descricao', headerName: 'Item', width: 530 },
        { field: 'ped_in_codigo', headerName: 'Pedido', width: 100 },
        { field: 'agn_st_fantasia', headerName: 'Cliente', width: 300 },
        {
            field: 'dt_calc_prog',
            headerName: 'Dias Prog.',
            width: 100
        },
        {
            field: 'acao',
            headerName: 'AÇÕES',
            width: 100,
            sortable: false,
            renderCell: (params) => <ActionButtons row={params.row} openFirst={setOpenFirstModal} setCurrentRow={setCurrentRow} />
        }
    ];
    const api = useApi();
    ////////////////////////////////////// STATES /////////////////////////////////////////
    const [loading, setLoading] = useState(true);
    const [ordens, setOrdens] = useState([]);
    const [quantidadeItensDistintos, setQuantidadeItensDistintos] = useState(0);
    const color = '#0588ed';
    const [openFirstModal, setOpenFirstModal] = useState(false);
    const [openSecondModal, setOpenSecondModal] = useState(false);
    const [rowSelectedSecondModal, setRowSelectedSecondModal] = useState([]);
    const [currentRow, setCurrentRow] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [filteredOrdens, setFilteredOrdens] = useState([]);

    //para sempre atualizar a tabela
    useEffect(() => {
        setFilteredOrdens(ordens);
    }, [ordens]);

    ////////////////////////////////////// FUNÇÕES /////////////////////////////////////////
    const formatDate = (dateString) => {
        const inputDate = new Date(dateString);
        const day = String(inputDate.getDate()).padStart(2, '0');
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const year = inputDate.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const getOrder = async () => {
        try {
            const response = await api.getOrderFP();

            const parsedData = response.data.map((i, index) => ({
                ...i,
                id: index + 1,
                ord_dt_confirmacao: formatDate(i.ord_dt_confirmacao)
            }));
            setOrdens(parsedData);

            const distinctItems = new Set(parsedData.map((item) => item.ped_in_codigo));
            setQuantidadeItensDistintos(distinctItems.size);
            setLoading(false);
        } catch (error) {
            toast.error('Erro ao conectar no banco de dados, tente novamente');
        }
    };

    useEffect(() => {
        getOrder();
    }, []);

    return (
        <MainCard title={<h2 style={{ margin: '0' }}>Ordens aguardando análise crítica</h2>}>
            <Grid container spacing={gridSpacing}>
                <FirstModal
                    open={openFirstModal}
                    setOpen={setOpenFirstModal}
                    currentRow={currentRow}
                    setRowSelectedSecondModal={setRowSelectedSecondModal}
                    setOpenSecondModal={setOpenSecondModal}
                />
                <SecondModal open={openSecondModal} setOpen={setOpenSecondModal} currentRow={rowSelectedSecondModal} />
                {loading && (
                    <Box sx={{ minHeight: '80vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress />
                    </Box>
                )}
                {!loading && (
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', padding: '1em' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                position: 'absolute',
                                right: '70px',
                                top: '115px'
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex'
                                }}
                            >
                                <HoverSocialCard
                                    sx={{ marginRight: '3em' }}
                                    primary="PEDIDOS"
                                    secondary={quantidadeItensDistintos}
                                    iconPrimary={AppRegistrationIcon}
                                    color={color}
                                />
                                <HoverSocialCard
                                    sx={{ marginRight: '3em' }}
                                    primary="ITENS"
                                    secondary={ordens.length}
                                    iconPrimary={EventNoteIcon}
                                    color={color}
                                />
                            </Box>
                        </Box>

                        <Box>
                            <DataGrid
                                rows={ordens}
                                columns={columns}
                                rowHeight={50}
                                sx={{ maxWidth: '1400px', margin: '0 auto' }}
                                hideFooter={true}
                            />
                        </Box>
                    </Box>
                )}
            </Grid>
        </MainCard>
    );
};

export default OrdemFP;
